import { useCallback, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Card } from 'components/@shared/Card';
import { BackdropLoader } from 'components/@shared/Loaders';
import { ResetPasswordForm } from 'components/Auth/ResetPasswordForm';
import { forgotPasswordByEmail } from 'services/authService';

export const ForgotPasswordPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [successSend, setSuccessSend] = useState(false);

    const resetPasswordHandler = useCallback((email: string) => {
        setIsLoading(true);
        forgotPasswordByEmail(email)
            .then(() => {
                setSuccessSend(true);
            })
            .finally(() => setIsLoading(false));
    }, []);

    return (
        <Box px={2.5} py={2} display="flex" width="100%" height="100%" alignItems="center" justifyContent="center">
            <Card title="Reset Password">
                {successSend ? (
                    <Box py={4}>
                        <Typography textAlign="center">Email has been sent. Please check it</Typography>
                    </Box>
                ) : (
                    <ResetPasswordForm onReset={resetPasswordHandler} />
                )}
            </Card>
            {isLoading && <BackdropLoader />}
        </Box>
    );
};
